import { render, staticRenderFns } from "./ChooseOwnerPixKey.vue?vue&type=template&id=98efdbfa&"
import script from "./ChooseOwnerPixKey.vue?vue&type=script&lang=js&"
export * from "./ChooseOwnerPixKey.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOwnerPixKey.vue?vue&type=style&index=0&id=98efdbfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports